import React from "react";
import {  View, Animated } from "react-native";
import {CreateResponsiveStyle,} from "rn-responsive-styles";
import { COLORS, FONTS } from "../constant";
import CDropdown from "./CDropdown";
import CInput from "./CInput";
import CText from "./CText";


const CPrefixInputDropdown = ({ label,pickerValue, value, items, onSelect, mandatoryField,customStyle,disable,onChangeText }) => {
    const styles = useStyles();

    return(
        <View>
             <CText.inputTopLabel>
          {label}
          {
            mandatoryField
            ? <Animated.Text
            style={[
              styles.inlineError,
              { color: "#f00", fontSize: 15, fontWeight: "500" },
            ]}
          >
            {" *"}
          </Animated.Text>
          : null
          }
          
          </CText.inputTopLabel>
          <View style={[styles.inputStyle,{flexDirection:"row",marginTop:10
        }]}>
            <View style={{alignSelf:"center",marginTop:-10}}>
            <CDropdown
                customStyle={styles.inputWidth}
                value={pickerValue}
                items={items}
                onSelect={onSelect}
              />
            </View>
            
            <CInput
              style={{ width: 160,borderRadius:10,height:38,
               borderWidth:0,
               }}
              value={value}
              onChangeText={onChangeText}
            />
        </View>
        </View>
        
    )
}

const useStyles = CreateResponsiveStyle(
    {
      inputWidth: {
        width: 70,
        borderRadius:0,
        borderTopLeftRadius:10,
        borderTopRightRadius:10,
        borderBottomLeftRadius:10,
        borderWidth:0,
      },
      inlineError: {
        fontFamily: "Inter",
        fontSize: 12,
        color: "#db1a1a",
        marginTop: 3,
        marginLeft: 0,
      },
      inputStyle: {
        width: 230,
        height: 36.5,
        borderRadius: 8.3,
        backgroundColor: "rgba(0, 0, 0, 0)",
        borderStyle: "solid",
        borderWidth: 2,
        borderColor: COLORS.white1,
        fontFamily: FONTS.InterMedium,
        fontSize: 16,
        lineHeight: 18,
        letterSpacing: 0.1,
        textAlign: "left",
        color: COLORS.darkBlack,
        alignItems:"center",
        justifyContent:"center"
       
      },
    })

export default CPrefixInputDropdown;